import * as React from 'react';

import { translate } from '~l10n/client';

import { ExportFeedback } from './ExportFeedback';
import { Email } from './ExportFeedbackIcons';

const ExportFeedbackEmailMeComplete = ({ onBack }: { onBack: () => void }) => (
  <ExportFeedback
    onBack={onBack}
    icon={<Email />}
    title={translate('Sending')}
    message={translate('You will receive an email shortly.')}
  />
);

export { ExportFeedbackEmailMeComplete };
